import React from 'react';
interface HeaderProps {
  actionLabel: string;
  actionHref: string;
  onAction: () => void;
  isDark?: boolean;
}
export function Header({
  actionLabel,
  actionHref,
  onAction,
  isDark = false
}: HeaderProps) {
  return <header className="h-[80px] w-full px-8" data-id="element-124">
      <div className="flex h-full items-center justify-end" data-id="element-125">
        <a href={actionHref} onClick={event => {
        event.preventDefault();
        onAction();
      }} className={`rounded-sm text-fluid-sm text-[#7A8290] transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-1 ${isDark ? 'hover:text-white focus:ring-white/20 focus:ring-offset-[#111111]' : 'hover:text-[#111111] focus:ring-[#111111]/20 focus:ring-offset-white'}`} data-id="element-126">
          {actionLabel}
        </a>
      </div>
    </header>;
}